<div fxFlex="100" fxLayout="column" class="section-container">
  <ng-content></ng-content>
</div>
